import { useEffect, useState } from 'react';
import * as S from './style';
import introduceImg from '@/assets/img/introduce.jpg';
import mapImg from '@/assets/img/map.png';
import { Map, MapMarker } from 'react-kakao-maps-sdk';
import { CONF_PLACE, CONF_DATE, CONF_DATE_SUB } from '@/constants/menu';

const DEFAULT_MAP_POSITION = { lat: 35.2325658, lng: 129.0828635 };

const EventInfo = () => {
	const [mapPosition, setMapPosition] = useState(DEFAULT_MAP_POSITION);

	useEffect(() => {
		if (typeof kakao === 'undefined' || !kakao.maps?.services) return;

		const updateMapPosition = (lat: string, lng: string) => {
			setMapPosition({
				lat: Number(lat),
				lng: Number(lng),
			});
		};

		kakao.maps.load(() => {
			const geocoder = new kakao.maps.services.Geocoder();
			const places = new kakao.maps.services.Places();

			geocoder.addressSearch(CONF_PLACE, (result, status) => {
				if (status === kakao.maps.services.Status.OK && result[0]) {
					updateMapPosition(result[0].y, result[0].x);
					return;
				}

				places.keywordSearch(CONF_PLACE, (keywordResult, keywordStatus) => {
					if (keywordStatus === kakao.maps.services.Status.OK && keywordResult[0]) {
						updateMapPosition(keywordResult[0].y, keywordResult[0].x);
					}
				});
			});
		});
	}, []);

	return (
		<S.ConferenceBoardBox>
			{/* <S.ContentBox>
			<S.ContentTitle>초청의 글</S.ContentTitle>
			<S.ImgIntroduceBox>
				<img src={introduceImg} alt="소개 이미지" />
			</S.ImgIntroduceBox>
			<S.IntroduceContent>
				<p>존경하는 한국노화학회 회원 여러분, 그리고 참석자 여러분,</p>
				<p>안녕하십니까. 한국노화학회 회장 민경진입니다.</p>
				<p>
					따뜻한 햇살이 가득한 6월, ‘2025년 한국노화학회 춘계학술대회’를 인하대학교 항공우주 캠퍼스에서 개최하게 되어 매우 기쁘게 생각합니다. 바쁘신 일정 중에도
					귀한 시간을 내어 참석해 주신 모든 분들께 진심으로 감사의 말씀을 드립니다.
				</p>
				<p>
					이번 춘계학술대회의 주제는 “Understanding Aging Across Scales: From Basic Mechanisms to Functional Regulation”입니다. 이 주제는 세포 수준의 기초
					기전부터 유기체 수준의 기능 조절에 이르기까지, 노화 현상을 다차원적·통합적으로 이해하고자 하는 학문의 흐름을 반영하고 있습니다. 특히, 기초 연구의
					성과가 실제 건강수명 연장과 기능 유지에 어떻게 기여할 수 있는지를 모색하는 중요한 자리가 될 것입니다.
				</p>
				<p>
					이번 학술대회는 국내외 저명한 연구자들의 심도 깊은 강연과 더불어, 다양한 세부 세션 및 포스터 발표가 마련되어 있습니다. 서로의 연구 결과를 공유하고
					학문적 교류를 통해 노화에 대한 통합적 이해를 넓히는 소중한 시간이 되기를 기대합니다.
				</p>
				<p>아울러 이번 학술대회가 노화연구의 지평을 확장하고, 향후 실질적 건강노화 실현에 기여하는 출발점이 되기를 바랍니다.</p>
				<p>
					끝으로, 이번 학회를 준비해 주신 조직위원회와 후원 기관 관계자 여러분께 깊은 감사의 말씀을 드리며, 참석하신 모든 분들께 뜻깊고 유익한 시간이 되시길
					기원합니다.
				</p>
				<p>감사합니다.</p>
			</S.IntroduceContent>
			<S.SignBox>
				<p>2025 년 06 월</p>
				<div className="title_box">
					<span>한국노화학회장</span>
					<div className="name_box">
						<strong>민경진</strong>
					</div>
				</div>
			</S.SignBox>
		</S.ContentBox> */}
			<S.ContentBox>
				<S.ContentTitle>행사 일정</S.ContentTitle>
				<S.ScheduleBox>
					<S.ScheduleContent>
						<S.BorderBox>학술대회 일정</S.BorderBox>
						<S.PointFont>{CONF_DATE}</S.PointFont>
					</S.ScheduleContent>
					<S.ScheduleContent>
						<S.BorderBox>학술대회 장소</S.BorderBox>
						<p>{CONF_PLACE}</p>
					</S.ScheduleContent>
					{/* <S.ScheduleContent>
					<S.BorderBox>초록제출 기간</S.BorderBox>
					<S.PointFont>2025년 4월 25일 – 2025년 5월 30일</S.PointFont>
					</S.ScheduleContent> */}
					<S.ScheduleContent>
						<S.BorderBox>사전등록 기간</S.BorderBox>
						<S.ScheduleTextBox>
							<S.PointFont>{CONF_DATE_SUB}</S.PointFont>
						</S.ScheduleTextBox>
					</S.ScheduleContent>
				</S.ScheduleBox>
			</S.ContentBox>
			<S.ContentBox>
				<S.PaddedWrapper>
					<S.ContentTitle>행사장 안내</S.ContentTitle>
				</S.PaddedWrapper>
				<div>
					<S.ImgMapBox style={{ width: '100%', maxWidth: '844px' }}>
						<Map center={mapPosition} style={{ width: '100%', height: '400px' }} level={3}>
							<MapMarker position={mapPosition} />
						</Map>
					</S.ImgMapBox>
					{/* <S.MapBox>
					<S.MapContent>
						<div className="menu_box">인천 지하철 1호선</div>
						<p>테크노파크역 1번 출구 200M</p>
					</S.MapContent>
					<S.MapContent>
						<div className="menu_box">지역버스 간선</div>
						<p>9번, 지선 51-1(순환), 급행 909</p>
					</S.MapContent>
					<S.MapContent>
						<div className="menu_box">자차 이용시</div>
						<p> 항공우주산학융합원 내 주차장 이용</p>
					</S.MapContent>
				</S.MapBox> */}
				</div>
			</S.ContentBox>
			{/* <S.ContentBox>
			<S.ContentTitle>공동주관 및 후원</S.ContentTitle>
			<S.GridBox>
				{Array.from({ length: 7 }).map((_, i) => (
					<S.GridContentBox key={i}>
						<S.GridImgBox>
							<img src={conferenceImg} alt="컨퍼런스 이미지" />
						</S.GridImgBox>
						<div className="content_box">
							<span className="title">가천대학교</span>
							<span className="content">선천면역 매개 만성염증 질환 연구센터</span>
						</div>
					</S.GridContentBox>
				))}
			</S.GridBox>
		</S.ContentBox>
		<S.ContentBox>
			<S.ContentTitle>기업</S.ContentTitle>
			<S.GridBox>
				{Array.from({ length: 7 }).map((_, i) => (
					<S.GridContentBox key={i}>
						<S.GridImgBox>
							<img src={conferenceImg} alt="컨퍼런스 이미지" />
						</S.GridImgBox>
						<div className="content_box">
							<span className="title">가천대학교</span>
							<span className="content">선천면역 매개 만성염증 질환 연구센터</span>
						</div>
					</S.GridContentBox>
				))}
			</S.GridBox>
			</S.ContentBox> */}
		</S.ConferenceBoardBox>
	);
};

export default EventInfo;
